import { render, staticRenderFns } from "./CadastroPortal.vue?vue&type=template&id=52ec8cbc"
import script from "./CadastroPortal.vue?vue&type=script&lang=ts"
export * from "./CadastroPortal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports